import { render, staticRenderFns } from "./PortalConfig.vue?vue&type=template&id=84aa7d82&scoped=true&"
import script from "./PortalConfig.vue?vue&type=script&lang=js&"
export * from "./PortalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aa7d82",
  null
  
)

export default component.exports